module.exports = __webpack_public_path__ + "static/media/thumb.1abfb981.jpg";